import { GridCellProps } from "@progress/kendo-react-grid";

export function ValueOrDashCell({ field, dataItem }: GridCellProps) {
  const value = field ? dataItem[field] : undefined;
  const isEmptyCellValue =
    value === undefined || value === null || (typeof value === "string" && value.trim() === "");
  return <td>{isEmptyCellValue ? "-" : value}</td>;
}
